import { render, staticRenderFns } from "./Army.vue?vue&type=template&id=6ef3d76c&scoped=true&"
import script from "./Army.vue?vue&type=script&lang=js&"
export * from "./Army.vue?vue&type=script&lang=js&"
import style0 from "./Army.vue?vue&type=style&index=0&id=6ef3d76c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef3d76c",
  null
  
)

export default component.exports